import type { VAxios } from '../../define/axios/Axios';

/**
 * 智能生成 相关接口
 */
export const createApi = (defHttp: VAxios) => ({
  // 获取图片类型
  getScribbleType: (imgUrl: string) => {
    // defHttp.get({ url: `/editor/creation/scribble/type`, params: { imgUrl } }),
    return Promise.resolve('color_sketch');
  },
});
